module.exports = __webpack_public_path__ + "img/industry3.23277acf.jpg";